import React, { useEffect } from 'react'
import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'
import useInputValue from '@rehooks/input-value'
import { Alert, Box } from '@smooth-ui/core-sc'

import { SpinnerButton, Row, Col, Input } from 'components/Elements/index'

const MUTATION_APPLY_COUPON = gql`
  mutation applyCoupon($id: String!) {
    applyCoupon(id: $id) {
      id
      name
      amount_off
      duration_in_months
    }
  }
`

const Coupon = ({ coupon = '', setCoupon }) => {
  const couponField = useInputValue(coupon)
  const [applyCoupon, { loading, data, error }] = useMutation(
    MUTATION_APPLY_COUPON
  )

  useEffect(() => {
    if (data && data.applyCoupon) {
      setCoupon(data.applyCoupon)
    }
  }, [data, setCoupon])

  const onSubmit = async event => {
    event.preventDefault()
    if (!couponField.value) {
      return setCoupon(null)
    }
    try {
      await applyCoupon({
        variables: {
          id: couponField.value
        }
      })
    } catch (error) {
      console.log('error', error)
    }
  }
  useEffect(() => {
    if (coupon && !(data && data.applyCoupon)) {
      console.log('run inital check')
      applyCoupon({
        variables: {
          id: coupon
        }
      })
    }
  }, [coupon, applyCoupon, data])
  return (
    <>
      {error && <Alert variant="danger">Ikke gyldig rabatt-kode</Alert>}
      {data && <Alert variant="success">Denne rabatt-kode er gyldig</Alert>}
      {data && <CouponInfo coupon={data.applyCoupon} />}
      {!data && (
        <Row mb={3}>
          <Col col={{ xs: 3 / 5 }}>
            <Input
              name="coupon"
              placeholder="Din rabatt kode"
              autoCapitalize="none"
              {...couponField}
            />
          </Col>
          <Col col={{ xs: 2 / 5 }}>
            <SpinnerButton
              working={loading}
              type="button"
              text="Aktiver"
              width="100%"
              variant="secondary"
              onClick={onSubmit}
            />
          </Col>
          {couponField.value && !data && !error && (
            <Col col={{ xs: 5 / 5 }}>
              <div style={{ paddingTop: 10 }}>
                Husk å aktivere din rabatt-kode
              </div>
            </Col>
          )}
        </Row>
      )}
    </>
  )
}

export const CouponInfo = ({ coupon }) => {
  return (
    <Box mb={3}>
      <strong>{coupon.name}:</strong> Minus {coupon.amount_off / 100},-{' '}
      {coupon.duration_in_months
        ? `i ${coupon.duration_in_months} måneder`
        : 'per mnd'}
      .
    </Box>
  )
}

export default Coupon
